;(function (window, document) {

	'use strict'

	function filterInit(element) {

		// store filter for each group
		let filters = {
			preference: [],
			type: [],
		};

		let filterElements = {
			preference: document.querySelectorAll("input[type=radio][name=preference"),
			type: document.querySelectorAll("input[type=radio][name=type]"),
		};

		if ( filterElements.preference ) {
			for (var i = 0; i < filterElements.preference.length; i++) {
				filterElements.preference[i].addEventListener("click", function() {
					filters.preference = this.value;
					doFilter();
				}, false);
			}
		}

		if ( filterElements.type ) {
			for (var i = 0; i < filterElements.type.length; i++) {
				filterElements.type[i].addEventListener("click", function() {
					filters.type = this.value;
					doFilter();
				}, false);
			}
		}

		function doFilter() {
			let filterItems = element.querySelectorAll('.filter-item');

			if ( ! filterItems ) {
				return false;
			}

			for (var i = 0; i < filterItems.length; i++) {

				var isMatched         = true;
				var elementPreference = filterItems[i].getAttribute('data-preference');
				var elementType       = filterItems[i].getAttribute('data-type');

				if ( filters.type.length && ! elementType.includes(filters.type) ) {
					isMatched = false;
				}

				if ( filters.preference.length && ! elementPreference.includes(filters.preference) ) {
					isMatched = false;
				}

				if ( isMatched ) {
					filterItems[i].style.setProperty('display', 'initial');
				} else {
					filterItems[i].style.setProperty('display', 'none', 'important');
				}
			}

		};
	}

	// Load scripts on page load
	window.addEventListener('DOMContentLoaded', () => {
		const filterGrid = document.querySelector('.filter-container .products');
		if ( filterGrid ) {
			filterInit(filterGrid);
		}

		const filterTable = document.querySelector('.filter-container .wc-product-table tbody');
		if ( filterTable ) {
			filterInit(filterTable);
		}
	})

})(window, document);
